module.exports = __webpack_public_path__ + "img/volume.b34771b5.png";